<template>
    <!--コンテンツ-->
    <main class="renew3_top">

        <div class="renew3_wrapper">
            <h1 class="top_h1">履歴書・職務経歴書を無料で作成｜スマホ・パソコン対応</h1>
        </div>

        <!--メインバナー-->
        <div class="mv">
            <div class="renew3_wrapper mv_wrapper">
                <a href="https://portal.yagish.jp/know-how/resume-reason/" target="_blank" rel="noopener noreferrer"
                    class="mv_link">
                    <img src="/static/renew3_img/top_knowhow_resume20260617.png" alt="履歴書の書き方" class="mv_img">
                </a>
            </div>
        </div>


        <!-- static:skip -->
        <div class="news" v-if="noticeInfo">
            <div data-v-450fc904 class="renew3_wrapper">
                <p class="news_text">お知らせ｜<a :href="noticeInfo.linkurl" target="_blank"
                        v-if="noticeInfo.linktarget == '1'" class="news_link">{{
                            noticeInfo.contexts }}</a><a :href="noticeInfo.linkurl" v-else class="news_link">{{
                            noticeInfo.contexts }}</a></p>
            </div>
        </div>
        <!-- /static:skip -->

        <!--テンプレート選択-->
        <div class="format">
            <div class="renew3_wrapper format_wrapper">

                <!--テンプレートブロック-->
                <div id="rirekisyo-index" class="format_block format_block1">
                    <h2 class="format_block_h2">人気のテンプレート</h2>

                    <div class="flex format_block_flex">
                        <a href="/format/rirekisho_job_change" id="toplnk_rirekisho_job_change" class="format_link">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_change.png" alt="転職用の履歴書（JIS規格）テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3 format_link_h3big">転職履歴書</h3>
                                <p class="format_link_txt">（JIS規格）</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/shokumukeirekisho" id="toplnk_shokumukeirekisho"
                            class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top format_link_top2">
                                <p class="format_link_memo">A4／複数枚</p>
                                <img src="/static/img/formats/shokurekisho-min.png" alt="職務経歴書" class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1 format_link_bottom2">
                                <h3 class="format_link_h3 format_link_h3big">職務経歴書</h3>
                                <p class="format_link_txt">編年体式(時系列)</p>
                            </div>
                            <button class="format_btn format_btn2">この経歴書でつくる</button>
                        </a>
                        <a href="/format/rirekisho_job_new" id="toplnk_rirekisho_job_new"
                            class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_job_new.png" alt="新卒履歴書"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">新卒履歴書</h3>
                                <p class="format_link_txt">職歴欄なしでアピール欄広め</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>
                        <a href="/format/rerekisho_part_time" id="toplnk_rerekisho_part_time"
                            class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／2枚</p>
                                <img src="/static/img/formats/rirekisho_part_time.png" alt="アルバイト用の履歴書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">アルバイト履歴書</h3>
                                <p class="format_link_txt">勤務曜日・勤務期間記入可能</p>
                            </div>
                            <button class="format_btn">この履歴書でつくる</button>
                        </a>

                    </div>

                    <div class="format_more">
                        <a href="/static/rirekisholist" class="format_more_btn">＞多様なテンプレートを見る</a>
                    </div>

                </div>

                <!--テンプレートブロック-->
                <div id="other-index" class="format_block format_block3">
                    <h2 class="format_block_h2">おすすめのテンプレート</h2>

                    <div class="flex format_block_flex">

                        <a href="/recognition" id="toplnk_ocr_recommend" class="format_link format_link_ocr">
                            <p class="format_link_memo">手書きも可</p>
                            <span class="ocr_label">
                                <span class="ocr_label_main">お手持ちの履歴書を<br>データに変換</span>
                                <span class="ocr_label_sub">対応ファイル：DOCX、PDF、HTML、TXT、EXCEL、PNG、JPG</span>
                            </span>
                        </a>

                        <a href="/format/myprofile" id="toplnk_myprofile" class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">ヤギフレンズ</p>
                                <img src="/static/img/formats/sample/myprofile_01.png" alt="マイプロフィール"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom format_link_bottom1">
                                <h3 class="format_link_h3">マイプロフィール</h3>
                                <p class="format_link_txt">懐かしのプロフィール</p>
                            </div>
                            <button class="format_btn">プロフィールをつくる</button>
                        </a>

                        <a href="/format/letter" id="toplnk_rirekisho_job_change"
                            class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/sample/yagish_letter_img.jpeg" alt="送付状テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">送付状</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">この送付状をつくる</button>
                        </a>
                        <a href="/format/taishokutodoke" id="toplnk_taishokutodoke"
                            class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/sample/yagish_taishokutodoke_img.jpeg" alt="退職願・退職届テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">退職願・退職届</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">この退職願をつくる</button>
                        </a>
                        <a href="/format/shiboudoukisho" id="toplnk_shiboudoukisho"
                            class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/sample/shiboudoukisho.jpg" alt="志望動機書テンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">志望動機書</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">志望動機書をつくる</button>
                        </a>
                        <a href="/format/entrysheet" id="toplnk_entrysheet" class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4／1枚</p>
                                <img src="/static/img/formats/sample/entrysheet_img.png" alt="エントリーシートテンプレート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">エントリーシート</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="pc format_btn format_btn3">エントリーシートをつくる</button>
                            <button class="sp format_btn format_btn3">このESをつくる</button>
                        </a>
                        <a href="/format/skillsheet_type" id="toplnk_skillsheet"
                            class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">A4</p>
                                <img src="/static/img/formats/sample/skillsheet.png" alt="スキルシート"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">スキルシート</h3>
                                <!--<p class="format_link_txt"></p>-->
                            </div>
                            <button class="format_btn format_btn3">スキルシートをつくる</button>
                        </a>
                        <a href="/idphotoprint" id="toplnk_idphotoprint" class="format_link format_link_outline">

                            <!--テンプレート上段-->
                            <div class="format_link_top">
                                <p class="format_link_memo">L判シール</p>
                                <img src="/static/img/formats/sample/idphotoprint.png" alt="証明写真印刷"
                                    class="format_link_img">
                            </div>

                            <!--テンプレート下段-->
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">証明写真印刷</h3>
                            </div>
                            <button class="format_btn format_btn3">証明写真を印刷する</button>
                        </a>
                        <!--<a href="/ai/interview_practice" id="toplnk_interview_practice" class="format_link"
                            v-if="$globalVar.in_app_payments">
                            <div class="format_link_top">
                                <img src="/static/renew3_img/format_aiinterview_fortop.png" alt="AIと面接練習"
                                    class="format_link_img">
                            </div>
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">AIヤギと面接</h3>
                                <p class="format_link_txt">気軽にチャットで何度も</p>
                            </div>
                            <button class="format_btn format_btn3">模擬面接する</button>
                        </a>
                        <a href="https://portal.yagish.jp/know-how/convenience-store-print/"
                            id="toplnk_rirekisho_job_change" target="_blank" class="format_link">
                            <div class="format_link_top">
                                <img src="https://portal.yagish.jp/wp-content/uploads/2024/12/yagi-print.png"
                                    alt="コンビニ印刷" class="format_link_img">
                            </div>
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">履歴書をコンビニや家で印刷</h3>
                            </div><button class="format_btn format_btn3">記事を読む</button>
                        </a>
                        <a href="/yagidigram" id="yagidy" target="_blank" class="format_link">
                            <div class="format_link_top">
                                <img src="/static/img/servicelist/servicelist10.png" alt="コンビニ印刷"
                                    class="format_link_img">
                            </div>
                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">ヤギディ診断</h3>
                                <p class="format_link_txt">役立つ性格診断</p>
                            </div><button class="format_btn format_btn3">診断してみる</button>
                        </a>
                        <a href="/ai/aptitude_practice" id="toplnk_aptitude_practice" class="format_link"
                            v-if="$globalVar.in_app_payments">

                            <div class="format_link_top">
                                <img src="/static/renew3_img/format_aptitude_w_fortop.png" alt="言語・非言語問題"
                                    class="format_link_img">
                            </div>

                            <div class="format_link_bottom">
                                <h3 class="format_link_h3">AIで適性検査対策</h3>
                                <p class="format_link_txt">チャット形式で回答</p>
                            </div>
                            <button class="format_btn format_btn3">問題を解いてみる</button>
                        </a>-->
                        <a class="format_link"></a>
                    </div>
                </div>

            </div>
        </div>

        <!--ヤギッシュのサービス-->
        <div class="ygservice">
            <div class="renew3_wrapper ygservice_wrapper">
                <h2 class="ygservice_h2">ヤギッシュのサービス</h2>

                <div class="flex ygservice_list">
                    <div class="ygservice_item">
                        <p class="ygservice_step">STEP 1</p>
                        <h3 class="ygservice_item_h3">履歴書をつくるとき</h3>
                        <p class="ygservice_item_lead">AI活用で、スピーディーかつ魅力的に。</p>
                        <div class="ygservice_icon"><img src="/static/img/yagioffer-company/offer-nav-card01.png"
                                alt="履歴書をつくるとき"></div>
                        <ul class="ygservice_check">
                            <li>AIに文章作成をおまかせ</li>
                            <li>証明写真の背景透過</li>
                            <li>フォントの切り替え</li>
                            <li>24時間AI相談</li>
                        </ul>
                    </div>

                    <div class="ygservice_item">
                        <p class="ygservice_step">STEP 2</p>
                        <h3 class="ygservice_item_h3">保存・印刷・提出</h3>
                        <p class="ygservice_item_lead">スムーズな提出を。</p>
                        <div class="ygservice_icon"><img src="/static/img/yagioffer-company/offer-nav-card03.png"
                                alt="保存・印刷・提出"></div>
                        <ul class="ygservice_check">
                            <li>PDFで出力＆メール送信</li>
                            <li>全国のコンビニで印刷</li>
                            <li>クラウドでバックアップ</li>
                            <li>自動保存で安心</li>
                        </ul>
                    </div>

                    <div class="ygservice_item">
                        <p class="ygservice_step">STEP 3</p>
                        <h3 class="ygservice_item_h3">完成後の就活サポート</h3>
                        <p class="ygservice_item_lead">面接、分析、スカウトで内定へ。</p>
                        <div class="ygservice_icon"><img src="/static/img/yagioffer-company/offer-nav-card02.png"
                                alt="完成後の就活サポート"></div>
                        <ul class="ygservice_check">
                            <li>AIと面接練習・自己分析</li>
                            <li>詳細な適性検査</li>
                            <li>履歴書送信・スカウト受信</li>
                            <li>転職・就職支援サポート</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!--お役立ちコラム-->
        <!-- static:skip -->
        <div class="knowhow" v-if="knowhowPosts.length">
            <div class="renew3_wrapper knowhow_wrapper">
                <h3 class="knowhow_h3">お役立ちコラム</h3>

                <div class="flex knowhow_list">
                    <a v-for="post in knowhowPosts" :key="post.id" :href="post.link" target="_blank"
                        rel="noopener noreferrer" class="knowhow_item">
                        <div class="knowhow_thumb">
                            <img v-if="knowhowThumb(post)" :src="knowhowThumb(post)" :alt="post.title.rendered">
                        </div>
                        <p class="knowhow_date">{{ formatWpDate(post.date) }}</p>
                        <h4 class="knowhow_title" v-html="post.title.rendered"></h4>
                    </a>
                </div>

                <div class="knowhow_more">
                    <a :href="knowhowArchiveUrl" target="_blank" rel="noopener noreferrer"
                        class="format_more_btn">＞記事をもっと見る</a>
                </div>
            </div>
        </div>
        <!-- /static:skip -->

        <!--旧ヤギッシュのサービス-->
        <!--<div class="service">
            <div class="renew3_wrapper service_wrapper">
                <h3 class="service_h3">ヤギッシュのサービス</h3>

                <div class="service_list" v-if="$globalVar.in_app_payments">

                    <div class="service_item">
                        <p class="service_item_title">履歴書をつくりながらできること</p>
                        <div class="flex service_img_list">
                            <img src="/static/renew2_img/service09.png" alt="AIに文章作成" class="service_img_item">
                            <img src="/static/renew2_img/service13.png" alt="証明写真風加工" class="service_img_item">
                            <img src="/static/renew2_img/service08.png" alt="フォント切り替え" class="service_img_item">
                            <img src="/static/renew2_img/service11.png" alt="専属エージェント" class="service_img_item">
                            <a href="/format/rirekisho_job_change" class="service_img_item service_img_item--edit">
                                <img src="/static/renew2_img/service00.png" alt="作成">
                            </a>
                        </div>
                    </div>

                    <div class="service_item">
                        <p class="service_item_title">履歴書をつくったらできること</p>
                        <div class="flex service_img_list">
                            <img src="/static/renew2_img/service01.png" alt="PDFで出力&amp;メール送信" class="service_img_item">
                            <img src="/static/renew2_img/service02.png" alt="コンビニ印刷" class="service_img_item">
                            <img src="/static/renew2_img/service03.png" alt="バックアップ＆復元" class="service_img_item">
                            <img src="/static/renew2_img/service04.png" alt="自動でブラウザ保存" class="service_img_item">
                        </div>
                    </div>

                    <div class="service_item">
                        <p class="service_item_title">履歴書が完成してからもできること</p>
                        <div class="flex service_img_list">
                            <img src="/static/renew2_img/service10.png" alt="AIと面接練習" class="service_img_item">
                            <img src="/static/renew2_img/service14.png" alt="AIと自己分析" class="service_img_item">
                            <img src="/static/renew2_img/service15.png" alt="AIで適性検査" class="service_img_item">
                            <img src="/static/renew2_img/service05.png" alt="履歴書送信サービス" class="service_img_item">
                            <img src="/static/renew2_img/service12.png" alt="オファーサービス" class="service_img_item">
                            <img src="/static/renew2_img/service06.png" alt="転職相談就職支援" class="service_img_item">
                        </div>
                    </div>

                </div>

                <div class="flex formatbtn_list">
                    <a href="/format/rirekisho_job_change" class="formatbtn_link formatbtn_link1">履歴書をつくる</a>
                    <a href="/format/shokumukeirekisho" class="formatbtn_link formatbtn_link2">経歴書をつくる</a>
                    <a href="/format/letter" class="formatbtn_link formatbtn_link3">送付状をつくる</a>
                </div>

                <div class="top_yagiprime_bnr" v-if="$globalVar.in_app_payments">
                    <a href="/yagiprimeinfo" target="_blank">
                        <img src="../../public/static/renew3_img/top_primebnr_pc.png" alt="ヤギプライム加入"
                            class="pc top_yagiprime_bnrimg">
                        <img src="../../public/static/renew3_img/top_primebnr_sp.png" alt="ヤギプライム加入"
                            class="sp top_yagiprime_bnrimg">
                    </a>
                </div>
            </div>
        </div>-->

        <!--お問い合わせ-->
        <div class="contact">
            <div class="renew3_wrapper contact_wrapper">
                <div class="flex contact_list">
                    <a href="https://www.yagish.jp/contact/" target="_blank" class="pc contact_link">
                        <span>パートナーについての</span><br>相談をする</a>
                    <a href="/contact" class="contact_link">
                        <span>履歴書作成についての</span><br>お問い合わせ</a>
                    <a href="https://www.yagish.jp/contact/" target="_blank" class="sp contact_link">
                        <span>パートナーについての</span><br>相談をする</a>
                </div>
            </div>
        </div>

        <!--バナー-->

        <!--<floating-button />-->

    </main>
</template>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

/*共通*/
.renew3_top .renew3_wrapper {
    width: 100%;
    max-width: 980px;
    margin: 0 auto;
    padding: 0 20px;
}

/*ページタイトル*/
.renew3_top .top_h1 {
    font-weight: bold;
    font-size: 18px;
    line-height: 1.5;
    margin-bottom: 12px;
}

/*MV*/
.renew3_top .mv {
    margin-bottom: 12px;
}

.renew3_top .mv_img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
}

/*テンプレート選択*/
.renew3_top .format {
    margin-bottom: 60px;
}

.renew3_top .format_block {
    margin-bottom: 30px;
}

.renew3_top .format_block_h2 {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 8px;
    text-align: left;
    color: #404040;
}

.renew3_top .format_block_h2_2 {
    margin-bottom: 0;
}

.renew3_top .format_block_lead {
    font-size: 14px;
    margin-bottom: 20px;
}

.renew3_top .format_block_flex {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
}

.renew3_top .format_more {
    text-align: right;
    margin: 16px 0 8px;
}

.renew3_top .format_more_btn {
    display: inline-block;
    color: #E95B10;
    font-size: 14px;
    font-weight: bold;
    text-decoration: none;
    transition: transform 0.2s ease;
}

.renew3_top .format_more_btn:hover {
    transform: scale(1.05);
    opacity: 1;
    text-decoration: none;
    color: #E95B10;
}

.renew3_top .format_link {
    width: calc(25% - 15px);
    display: flex;
    flex-direction: column;
}

.renew3_top .format_link:hover {
    transform: scale(1.04);
    text-decoration: none;
    opacity: 1;
}

.renew3_top .format_link_top {
    position: relative;
    text-align: center;
    background: #eef5e8;
    border-radius: 5px 5px 0 0;
    height: 100px;
    overflow: hidden;
}

.renew3_top .format_link_top2 {
    background: #FEF5F1;
}

.renew3_top .format_link_ocr {
    position: relative;
    display: flex;
}

.renew3_top .format_link_outline {
    border: 1px solid #aac79a;
    border-radius: 5px;
    overflow: hidden;
}

.renew3_top .format_link_outline .format_link_top,
.renew3_top .format_link_outline .format_link_bottom {
    background: transparent;
}

.renew3_top .format_link_outline .format_btn {
    background: #0f9934;
    color: #ffffff;
}

.renew3_top .ocr_label {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border: 2px dotted #aac79a;
    border-radius: 5px;
    background: #eef5e8;
    color: #004d40;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.6;
    text-align: center;
}

.renew3_top .ocr_label_sub {
    margin-top: 10px;
    font-size: 10px;
    font-weight: normal;
    color: #999999;
    line-height: 1.4;
}

.renew3_top .youtube-card {

    .format_link_top {
        height: 150px;
        padding: 15px 10px;
        background: #FBEAED;

        @include max-width(sm) {
            height: 170px;
        }

        .format_link_memo {
            color: #E3165C;
            border: 1px solid #E3165C;
        }

        .format_link_img {
            width: 100%;
            padding-top: 0;
        }

        .sp {
            display: none;

            @include max-width(sm) {
                display: block;
                height: 100%;
                object-fit: cover;
            }
        }
    }

    .format_btn {
        background: #E3165C;
    }
}

.renew3_top .format_link_memo {
    position: absolute;
    display: inline-block;
    font-weight: bold;
    font-size: 10px;
    color: #e95b10;
    background: #ffffff;
    border: 1px solid #e95b10;
    padding: 0 10px;
    margin-right: 5px;
    border-radius: 25px;
    top: 5px;
    left: 5px;
}

.renew3_top .format_link_img {
    display: block;
    width: 90%;
    padding-top: 15px;
    margin: 0 auto;
}

.renew3_top .format_link_bottom {
    background: #eef5e8;
    padding: 14px;
    height: 80px;
}

.renew3_top .format_link_bottom2 {
    background: #FEF5F1;
}

.renew3_top .format_link_h3 {
    font-weight: bold;
    font-size: 16px;
    color: #004d40;
}

.renew3_top .format_link_txt {
    font-size: 12px;
}

.renew3_top .format_btn {
    width: 100%;
    padding: 10px;
    border: none;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background: #0f9934;
    border-radius: 0 0 4px 4px;
    margin-top: auto;
}

.renew3_top .format_btn:hover {
    opacity: 1;
}

.renew3_top .format_btn2 {
    background: #e95b10;
}

.renew3_top .format_btn3 {
    background: #004d40;
}

/*ヤギッシュのサービス*/
.renew3_top .ygservice {
    background: #eef5e8;
    padding: 60px 0 70px;
    margin-bottom: 60px;
}

.renew3_top .ygservice_h2 {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #004d40;
    margin-bottom: 40px;
}

.renew3_top .ygservice_list {
    flex-wrap: wrap;
    align-items: stretch;
    gap: 24px;
}

.renew3_top .ygservice_item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-radius: 16px;
    padding: 32px 28px;
    box-shadow: 0 4px 16px rgba(0, 77, 64, 0.06);
}

.renew3_top .ygservice_step {
    display: inline-block;
    padding: 4px 18px;
    border-radius: 999px;
    background: #0f9934;
    color: #ffffff;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.12em;
    margin-bottom: 16px;
}

.renew3_top .ygservice_item_h3 {
    font-size: 20px;
    font-weight: bold;
    color: #004d40;
    text-align: center;
    margin-bottom: 10px;
}

.renew3_top .ygservice_item_lead {
    font-size: 13px;
    line-height: 1.7;
    color: #666666;
    text-align: center;
    margin-bottom: 24px;
}

.renew3_top .ygservice_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: #eef5e8;
    margin-bottom: 24px;
}

.renew3_top .ygservice_icon img {
    width: 100px;
    height: 100px;
    object-fit: contain;
}

.renew3_top .ygservice_check {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    border-top: 1px solid #e6efdf;
    padding-top: 20px;
}

.renew3_top .ygservice_check li {
    position: relative;
    padding-left: 28px;
    margin-bottom: 14px;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.5;
    color: #333333;
}

.renew3_top .ygservice_check li:last-child {
    margin-bottom: 0;
}

.renew3_top .ygservice_check li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 1px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #0f9934;
    /* チェックマーク */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px 12px;
}

/*お役立ちコラム*/
.renew3_top .knowhow {
    margin-bottom: 60px;
}

.renew3_top .knowhow_h3 {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #004d40;
    margin-bottom: 40px;
}

.renew3_top .knowhow_list {
    flex-wrap: wrap;
    gap: 24px;
}

.renew3_top .knowhow_item {
    flex: 1;
    min-width: 0;
    text-decoration: none;
    color: inherit;
    transition: transform 0.2s;
}

.renew3_top .knowhow_item:hover {
    transform: translateY(-4px);
    opacity: 1;
    text-decoration: none;
}

.renew3_top .knowhow_thumb {
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 12px;
    overflow: hidden;
    background: #eef5e8;
    margin-bottom: 12px;
}

.renew3_top .knowhow_thumb img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.renew3_top .knowhow_date {
    font-size: 12px;
    color: #999999;
    margin-bottom: 6px;
}

.renew3_top .knowhow_title {
    font-size: 15px;
    font-weight: bold;
    line-height: 1.5;
    color: #1a1a1a;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.renew3_top .knowhow_more {
    text-align: right;
    margin-top: 24px;
}

/*サービス*/
.renew3_top .service {
    margin-bottom: 50px;
    background: #eef5e8;
    padding: 50px 0;
}

.renew3_top .service_h3 {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
}

.renew3_top .service_item {
    margin-bottom: 30px;
}

.renew3_top .service_item_title {
    position: relative;
    font-weight: bold;
    font-size: 16px;
    color: #E95B10;
    margin-bottom: 10px;
    padding-left: 10px;
}

.renew3_top .service_item_title::before {
    position: absolute;
    content: "";
    background: #E95B10;
    width: 5px;
    height: 25px;
    left: 0;
}

.renew3_top .service_img_list {
    justify-content: flex-start;
    flex-wrap: wrap;
}

.renew3_top .service_img_item {
    width: 100px;
    height: auto;
    margin-right: 8px;
}

.renew3_top .formatbtn_list {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.renew3_top .formatbtn_link {
    width: calc(100% / 3 - 5px);
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    padding: 8px 0;
    border: 3px solid #0f9934;
    border-radius: 50px;
    background: #0f9934;
}

.renew3_top .formatbtn_link:hover {
    transform: scale(1.03);
    text-decoration: none;
    opacity: 1;
}

.renew3_top .formatbtn_link2 {
    border: 3px solid #e95b10;
    background: #e95b10;
}

.renew3_top .formatbtn_link3 {
    border: 3px solid #004d40;
    background: #004d40;
}

.top_yagiprime_bnr {
    margin-top: 50px;
}

/*お問い合わせ*/
.renew3_top .contact {
    margin-bottom: 50px;
}

.renew3_top .contact_list {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.renew3_top .contact_link {
    width: calc(50% - 5px);
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    line-height: 1.4;
    padding: 10px 0;
    border: 3px solid #0f9934;
    border-radius: 5px;
}

.renew3_top .contact_link:hover {
    background: #c7deb3;
    text-decoration: none;
    opacity: 1;
}

.renew3_top .contact_link span {
    font-size: 14px;
}

/*SP*/
@media screen and (max-width: 640px) {

    /*共通*/
    .renew3_top .renew3_wrapper {
        width: 100%;
    }

    /*ページタイトル*/
    .renew3_top .top_h1 {
        font-size: 15px;
        margin-bottom: 10px;
    }

    /*フォーマット選択*/
    .renew3_top .format_block_flex {
        gap: 10px;
    }

    .renew3_top .format_link {
        width: calc(50% - 5px);
    }

    .renew3_top .ocr_label {
        font-size: 13px;
    }

    .renew3_top .format_link_bottom1 {
        height: 90px;
    }

    /*ヤギッシュのサービス*/
    .renew3_top .ygservice_list {
        flex-direction: column;
    }

    /*お役立ちコラム*/
    .renew3_top .knowhow_list {
        flex-direction: column;
    }

    .renew3_top .format_link_h3 {
        font-size: 14px;
    }

    .renew3_top .format_btn {
        font-size: 14px;
    }

    /*ヤギッシュのサービス*/
    .renew3_top .service_img_list {
        justify-content: space-between;
    }

    .renew3_top .service_item:last-child {
        margin-bottom: 50px;
    }

    .renew3_top .service_img_item {
        margin-top: 8px;
        width: calc(100% / 3 - 10px);
    }

    .renew3_top .service_img_item:nth-of-type(1),
    .renew3_top .service_img_item:nth-of-type(2),
    .renew3_top .service_img_item:nth-of-type(3) {
        margin-top: 0;
    }

    .renew3_top .service_img_item:nth-of-type(3n-1):nth-last-of-type(1) {
        margin-right: auto;
    }

    .service_img_item--edit {
        margin-top: 8px !important;
        margin-right: auto !important;
    }

    .renew3_top .formatbtn_link {
        width: 250px;
        margin: 0 auto 15px;
    }

    .renew3_top .formatbtn_link:last-child {
        margin-bottom: 0;
    }

    /*お問い合わせ*/
    .renew3_top .contact_link {
        width: 100%;
        margin-bottom: 15px;
    }

    .renew3_top .contact_link:last-child {
        margin-bottom: 0;
    }

    .renew3_top .format_link_h3big {
        font-size: 16px;
    }

}
</style>
<style scoped>
.renew3_top .news {
    margin-bottom: 12px;
}

.renew3_top .news_text {
    border: 1px solid #0F9934;
    border-radius: 10px;
    padding: 10px;
    font-size: 12px;
}
</style>
<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
import FloatingButton from '../components/yagiprime/FloatingButton.vue'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'

// const MessageInvoker = {
//     postMessage: function (message) {
//         console.error(`Message received: ${message}`)
//     }
// }
export default {
    props: {
        affId: {
            type: String
        },
        oemId: {
            type: String
        }
    },
    components: {
        'blog-widget': blogWidget,
        'yagi-omikuji': YagiOmikuji,
        Slick,
        'floating-button': FloatingButton
    },
    data: function () {
        return {
            unLoginBanner: '/static/renew3_img/yagish_eprint20241114.png',
            unLoginBannerId: 'top_eprint_bnr',
            unLoginBannerLnk: '',
            oemList: ['kokudo-bl'],
            is_not_midnight: true,
            recentEdit: {
                FormatId: ''
            },
            topflag: '2',
            top_pattern: 'ptn1b',
            isWhat: true,
            isWho: false,
            selectedKind: '',
            selectedHash: '',
            mvBanner: 1,
            noticeInfo: null,
            knowhowPosts: [],
            knowhowArchiveUrl: 'https://portal.yagish.jp/know-how/',
            isSpecial20240508: false,
            slickOptions: {
                centerMode: true,
                // centerPadding: '-20px',
                variableWidth: false,
                accessibility: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 4000,
                asNavFor: '.slider-nav',
                speed: 400
            },
            slickNavOptions: {
                focusOnSelect: true,
                asNavFor: '.slider-for',
                variableWidth: false,
                slidesToShow: 5,
                centerPadding: '20px'
            },
            randomNumber: 0
        }
    },
    methods: {
        // prefetchEprintHelp() {
        //     if (this._eprintPrefetched) return
        //     this._eprintPrefetched = true
        //     import(/* webpackPrefetch: true */ '@/views/pages/EprintHelp')
        // },
        searchHash: function (_hash) {
            this.selectedHash = _hash
        },
        searchKind: function (_kind) {
            this.selectedKind = _kind
        },
        knowhowThumb: function (post) {
            const media = post._embedded && post._embedded['wp:featuredmedia']
            if (media && media[0]) {
                const sizes = media[0].media_details && media[0].media_details.sizes
                if (sizes && sizes.medium) return sizes.medium.source_url
                return media[0].source_url
            }
            return ''
        },
        formatWpDate: function (d) {
            return d ? d.slice(0, 10).replace(/-/g, '.') : ''
        },
        getLink: function (f_id) {
            if (f_id == 'line_yagibot') {
                return process.env.VUE_APP_YAGIBOT_URL // 'https://lin.ee/lQ9AmgT' // https://lin.ee/FniFZ1i
            } else if (f_id == 'y') {
                return 'https://portal.yagish.jp/know-how/mid-career_how-to-write/#index2'
            } else {
                return '/format/' + f_id + '?frm=' + this.top_pattern
            }
        },
        getTarget: function (f_id) {
            if (f_id == 'line_yagibot') {
                return '_blank'
            } else {
                return ''
            }
        },
        reload: function () {
            location.reload(true)
        },
        recentEditClass: function (format) {
            if (!this.recentEdit) return
            if (this.recentEdit.FormatId === format.id) {
                return {
                    'current-edit': true
                }
            }
        },
        loadRecentEdit: function () {
            const app = this
            this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
                if (err) {
                    console.log(err)
                }
                if (data) {
                    app.recentEdit = data
                }
            })
        },
        updateRecentEdit: function (data) {
            if (data) {
                this.recentEdit = data
            }
        },
        toggleButton: function () {
            if (this.isWhat) {
                this.isWhat = false
                this.isWho = true
            } else {
                this.isWhat = true
                this.isWho = false
            }
            this.selectedKind = ''
            this.selectedHash = ''
        },
        getSelectedHash: function (classname, val) {
            if (val == this.selectedHash) {
                return classname + ' select'
            } else {
                return classname
            }
        },
        getSelectedKind: function (classname, val) {
            if (val == this.selectedKind) {
                return classname + ' select'
            } else {
                return classname
            }
        }
    },
    computed: {
        getMode: function () {
            return process.env.VUE_APP_MODE
        },
        forSearchHashs: function () {
            const _rtVal = []
            if (this.selectedHash) {
                for (const obj of this.$site.rirekishoFormatsIndex) {
                    for (const _hash of obj.hashs) {
                        if (_hash == this.selectedHash) {
                            _rtVal.push(obj)
                        }
                    }
                }
                return _rtVal
            } else {
                return this.$site.rirekishoFormatsIndex
            }
        }
    },
    created: function () {
        // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
        this.loadRecentEdit()
        const now = new Date()
        if (now.getHours() >= 0 && now.getHours() < 6) {
            this.is_not_midnight = false
        }

        if (Math.floor(Math.random() * 2) == 0) {
            this.topflag = '1'
            this.top_pattern = 'ptn1a'
        } else {
            this.topflag = '2'
            this.top_pattern = 'ptn1b'
        }
        this.topflag = '4'
        this.top_pattern = 'ptn2b_list'
        if (this.$site.appFlag == 'b') {
            this.topflag = '3'
            this.top_pattern = 'app'
        }
        this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
        this.$eventHub.$on('reload', this.reload)

        const nowdate = new Date()
        const date1 = new Date('2024/05/09 00:00:00')
        const date2 = new Date('2024/05/12 23:59:59')
        if (nowdate > date1 && nowdate < date2) {
            this.isSpecial20240508 = true
        } else {
            this.isSpecial20240508 = false
        }
        if (Math.floor(Math.random() * 2) == 0 && false) {
            this.unLoginBanner = '/static/renew3_img/yagiprime_superegent20241114.png'
            this.unLoginBannerId = 'top_superagent_bnr'
            this.unLoginBannerLnk = '/yagiprime_superagent'
        }

        const app = this

        const formData = new FormData()
        this.$axios
            .post(this.$varuna.endPoints.getNoticeinformation, formData, { timeout: 60000 })
            .then(function (response) {
                console.error(response.data)
                for (const _key in response.data.notice_list) {
                    app.noticeInfo = response.data.notice_list[_key]
                    break
                }
            })
            .catch(function (error) {
            }).finally(function () {
            })

        // お役立ちコラム（WordPress /know-how/ カテゴリ ID:58）を3件取得（常に本番ポータルを参照）
        const portalBase = 'https://portal.yagish.jp'
        this.$axios
            .get(portalBase + '/wp-json/wp/v2/posts', {
                params: { categories: 58, per_page: 3, _embed: true },
                timeout: 60000
            })
            .then(function (response) {
                app.knowhowPosts = response.data
            })
            .catch(function (error) {
                console.error('お役立ちコラムの取得エラー', error)
            })
    },
    destroyed: function () {
        this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
        this.$eventHub.$off('reload', this.reload)
    },
    beforeMount: function () {
        this.$globalVar.googleAdsTagCheck('', '')
        if (Math.floor(Math.random() * 2) == 0) {
            this.randomNumber = 0
        } else {
            this.randomNumber = 1
        }
        console.error(this.affId)
        if (this.affId) {
            console.error(this.affId)
            this.$cookies.config(60 * 60 * 24, '')
            this.$cookies.set('_YAGISH_AFFILIATE_ID', this.affId, null, null, 'yagish.jp')
            this.$cookies.set('_YAGISH_AFFILIATE_ID', this.affId, null, null, 'localhost')
        }
        if (this.oemList.indexOf(this.oemId) >= 0) {
            console.error(this.oemId)
            this.$cookies.config(60 * 60 * 24, '')
            this.$cookies.set('_YAGISH_OEM_ID', this.oemId, null, null, 'yagish.jp')
            this.$cookies.set('_YAGISH_OEM_ID', this.oemId, null, null, 'localhost')
            this.$cookies.set('_YAGISH_AFFILIATE_ID', this.oemId, null, null, 'yagish.jp')
            this.$cookies.set('_YAGISH_AFFILIATE_ID', this.oemId, null, null, 'localhost')
        }
    }
}
</script>
